export default function Footer() {
  return (
    <footer className="py-12 bg-white text-slate-600 border-t border-slate-200/80 text-xs sm:text-sm">
      <div className="w-full max-w-[1200px] mx-auto px-8 relative z-10">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pb-8 border-b border-slate-200">
          {/* Brand & Address */}
          <div className="space-y-1.5">
            <div className="flex items-center gap-2">
              <img
                src="https://echoleads.ai/assets/Echoleads%20Logo-02%203.png"
                alt="EchoLeads Logo"
                className="h-6 w-auto"
              />
              <span className="text-slate-400">·</span>
              <span className="text-xs text-slate-500">
                AI voice calling sales agent
              </span>
            </div>
            <p className="text-xs text-slate-500">
              T-Hub, Knowledge City, Hyderabad, Telangana 500081, India
            </p>
          </div>

          {/* Legal / Site Links */}
          <div className="flex flex-wrap items-center gap-6 text-xs sm:text-sm text-slate-600">
            <a href="https://echoleads.ai" className="hover:text-slate-900 transition-colors">
              echoleads.ai
            </a>
            <a href="/privacy-policy" className="hover:text-slate-900 transition-colors">
              Privacy Policy
            </a>
            <a href="/terms-of-service" className="hover:text-slate-900 transition-colors">
              Terms of Service
            </a>
            <a href="/refund-policy" className="hover:text-slate-900 transition-colors">
              Refund Policy
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-6 text-xs text-slate-500">
          © 2026 EchoLeads.ai. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
